import LegacyRouteRedirect from '@/components/navigation/LegacyRouteRedirect';
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Equipment = lazy(() => import('./Equipment'));

const EquipmentCleaning = lazy(() => import('./EquipmentCleaning'));

const EquipmentCleaningLogs = lazy(() => import('./EquipmentCleaningLogs'));

const EquipmentGraveyard = lazy(() => import('./EquipmentGraveyard'));

/**
 * The Equipment routes.
 */
const equipmentRoutes: FuseRouteItemType[] = [
	{
		path: 'equipment',
		children: [
			{ index: true, element: <LegacyRouteRedirect to="/equipment/stock" /> },
			{
				path: 'stock',
				element: <Equipment />
			},
			{
				path: 'stock/:equipmentId',
				element: <Equipment />
			},
			{
				path: 'needs-cleaning',
				element: <EquipmentCleaning />
			},
			{
				path: 'cleaning-logs',
				element: <EquipmentCleaningLogs />
			},
			{
				path: 'stock/graveyard',
				element: <EquipmentGraveyard />
			}
		]
	}
];

export default equipmentRoutes;
